import { render, staticRenderFns } from "./MbInitiateProcess.vue?vue&type=template&id=3cc2212b&scoped=true"
import script from "./MbInitiateProcess.vue?vue&type=script&lang=js"
export * from "./MbInitiateProcess.vue?vue&type=script&lang=js"
import style0 from "./MbInitiateProcess.vue?vue&type=style&index=0&id=3cc2212b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc2212b",
  null
  
)

export default component.exports